import { render, staticRenderFns } from "./InformeproveLink.vue?vue&type=template&id=6ee19dea&scoped=true&"
import script from "./InformeproveLink.vue?vue&type=script&lang=js&"
export * from "./InformeproveLink.vue?vue&type=script&lang=js&"
import style0 from "./InformeproveLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InformeproveLink.vue?vue&type=style&index=1&id=6ee19dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee19dea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VBtn,VCard,VCardText,VCol,VForm,VIcon,VRow,VSpacer,VToolbar,VToolbarTitle})
